import {
    SET_APP_CAPTCHA
} from '../constants/actionTypes'


export const setAppCaptcha = (token) => ({
    type: SET_APP_CAPTCHA,
    token
})
